import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const BusinessWebsitesPage: React.FC = () => {
  return <ServicePageTemplate slug="business-websites" />;
};

export default BusinessWebsitesPage;
